import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';
import { imagesRequest } from '../actions';

const { takeEvery, put } = sagaEffects;

function* handler({ payload: image }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        const ref = yield firestore.collection('images');
        yield ref.add(image);

        yield put(imagesRequest({ silent: true }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.images.add' }));
    }
}
export default function* () {
    yield takeEvery(types.ADD_IMAGE_REQUEST, handler);
}
